import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { TrendingUp, Eye, Clock, Play, MousePointerClick, PhoneIncoming, Repeat } from 'lucide-react';

const fmtMin = (s) => `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')} min`;
const plural = (n, word) => `${n} ${word}${n !== 1 ? 's' : ''}`;

export const WeeklyEngagementWidget = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.getWeeklyEngagement().then(r => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats || (!stats.scans && !stats.contact_taps && !stats.leads)) return null;

  const items = [
    { icon: Eye, color: 'text-sky-400', label: plural(stats.scans, 'scan'), testid: 'weekly-eng-scans' },
    stats.avg_seconds > 0 && { icon: Clock, color: 'text-sky-400', label: `Ø ${fmtMin(stats.avg_seconds)} on page`, testid: 'weekly-eng-avg-time' },
    stats.media_plays > 0 && { icon: Play, color: 'text-sky-400', label: plural(stats.media_plays, 'media play'), testid: 'weekly-eng-plays' },
    { icon: MousePointerClick, color: 'text-emerald-400', label: plural(stats.contact_taps, 'contact tap'), testid: 'weekly-eng-taps' },
    stats.leads > 0 && { icon: PhoneIncoming, color: 'text-emerald-400', label: plural(stats.leads, 'lead'), testid: 'weekly-eng-leads' },
    stats.returning_visitors > 0 && { icon: Repeat, color: 'text-orange-400', label: plural(stats.returning_visitors, 'returning visitor'), testid: 'weekly-eng-returning' },
  ].filter(Boolean);

  return (
    <div className="bg-sky-500/[0.05] border border-sky-500/25 rounded-sm px-3.5 py-2.5" data-testid="weekly-engagement-widget">
      <div className="flex items-center gap-x-3 gap-y-1 flex-wrap">
        <span className="inline-flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-sky-400" />
          <span className="text-xs font-medium text-sky-300">Engagement this week</span>
        </span>
        {items.map((it) => (
          <span key={it.testid} data-testid={it.testid}
            className="inline-flex items-center gap-1 text-[11px] text-muted-foreground">
            <it.icon className={`w-3 h-3 ${it.color}`} />{it.label}
          </span>
        ))}
      </div>
    </div>
  );
};
